import React, { useState } from 'react';
import { Loader2, Search, Send } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from './ui/input';
import { Button } from './ui/button';

/** Admin: pick the catalogue product that fulfils a part request → customers get the « part available » e-mail. */
const LinkProductRow = ({ row, onDone, search, link }) => {
  const [q, setQ] = useState(row.query || '');
  const [results, setResults] = useState(null);
  const [busy, setBusy] = useState(false);
  const [sending, setSending] = useState(null);
  const find = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try { setResults((await search(q)).slice(0, 6)); } catch { setResults([]); } finally { setBusy(false); }
  };
  const choose = async (p) => {
    setSending(p.id);
    try { const r = await link(p.id); toast.success(`${r.notified} client(s) prévenu(s) · demande marquée « Référencé »`); onDone(); }
    catch (err) { toast.error(err.response?.data?.detail || 'Envoi impossible'); } finally { setSending(null); }
  };
  return (
    <div className="space-y-2" data-testid={`link-product-${row.key}`}>
      <form onSubmit={find} className="flex items-center gap-2">
        <span className="text-xs text-gray-600 whitespace-nowrap">Produit du catalogue qui répond à « {row.query} » :</span>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nom, marque ou référence" className="h-8 max-w-xs text-sm" data-testid={`link-product-search-${row.key}`} />
        <Button type="submit" size="sm" variant="outline" disabled={busy || !q.trim()} className="h-8" data-testid={`link-product-find-${row.key}`}>{busy ? <Loader2 size={14} className="animate-spin" /> : <Search size={14} />}</Button>
      </form>
      {results && (results.length === 0 ? <p className="text-xs text-gray-500">Aucun produit trouvé — ajoutez-le d'abord au catalogue : les clients seront prévenus automatiquement.</p> : (
        <ul className="divide-y divide-gray-100 bg-white rounded border border-gray-200">
          {results.map((p) => (
            <li key={p.id} className="flex items-center gap-3 px-3 py-1.5 text-sm">
              <img src={p.image} alt="" className="w-8 h-8 object-contain bg-gray-50 rounded" />
              <span className="flex-1 min-w-0 truncate">{p.brand} · <strong>{p.ref}</strong> · {p.name}</span>
              <span className="text-xs text-gray-500 whitespace-nowrap">{Number(p.price).toFixed(2)} €</span>
              <Button size="sm" onClick={() => choose(p)} disabled={!!sending} className="h-7 bg-emerald-600 hover:bg-emerald-700 text-white text-xs" data-testid={`link-product-choose-${p.id}`}>{sending === p.id ? <Loader2 size={12} className="animate-spin" /> : <Send size={12} className="mr-1" />} Prévenir ({row.requests})</Button>
            </li>
          ))}
        </ul>
      ))}
    </div>
  );
};

export default LinkProductRow;
